/* eslint-disable prettier/prettier */
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map, of, switchMap } from 'rxjs';
import { PassportAuth } from '../../services/passport-auth';

@Component({
  selector: 'app-code',
  imports: [],
  templateUrl: './code.html',
  styleUrl: './code.scss',
})
export class CodeComponent {
  private route = inject(ActivatedRoute);
  private passportAuth = inject(PassportAuth);
  private code$ = this.route.queryParams.pipe(
    switchMap(params => {
      const code = params['code'];
      if (!code) {
        return of(null);
      }
      if (typeof code === 'string') {
        return of(code);
      }
      return of();
    }),
  )

  constructor() {
    this.code$.pipe(
      distinctUntilChanged(),
      map(code => {
        if (code) {
          this.passportAuth.authenticateWithCode(code);
        }
      }),
      takeUntilDestroyed(),
    ).subscribe()
  }
}
